<template>
  <div class="add-partner container-style">
    <el-card class="searchCard" shadow="never">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        v-loading="formLoading"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="姓名" prop="userName">
              <el-input v-model="ruleForm.userName" placeholder="请输入加盟商姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="账号" prop="userAccount">
              <el-input v-model="ruleForm.userAccount" placeholder="请输入账号，用于加盟商登录"  :disabled="isEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
          <el-col :span="10">
            <el-form-item label="联系方式" prop="phone">
              <div style="display:flex">
              <el-input v-model="ruleForm.phone" placeholder="请输入手机号" :disabled="isEdit"></el-input>
              <template v-if="!isEdit">
                 <el-button
                style="width:120px;margin-left:10px"
                @click="sendMsg"
                v-if="count===60"
                :loading="sendMsgLoading"
              >
                验证码
              </el-button>
              <el-button
                style="width:120px;margin-left:10px"
                @click="sendMsg"
                v-else
                disabled
              >
                {{ count }}s
              </el-button>
              </template>
              <template v-else>
              <ChangePhone
                :userAccount='ruleForm.userAccount'
                :phone='ruleForm.phone'
                @change="(newPhone)=>{ruleForm.phone = newPhone}">
              </ChangePhone>
              </template>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!isEdit">
          <el-col :span="10">
            <el-form-item label="验证码" prop="phoneCode">
              <el-input v-model="ruleForm.phoneCode" placeholder="1234"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="品牌" prop="brandIdList">
              <el-select
                v-model="ruleForm.brandIdList"
                filterable
                placeholder="请选择品牌"
                style="width:100%"
                multiple
                collapse-tags
              >
                <el-option
                  v-for="item in brandOptions"
                  :key="item.id"
                  :label="item.brandName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="所属区域" prop="selectedZoneIdList">
              <el-cascader
                v-model="ruleForm.selectedZoneIdList"
                style="width:100%"
                placeholder="请选择所属区域"
                :options="areaOptions"
                collapse-tags
                filterable
                :props="{
                  multiple: 'true',
                  value: 'id',
                  label: 'zoneName',
                  children: 'subZoneList',
                }"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="text-align:center;margin:50px 0">
          <el-button @click="handleGoout" style="width:120px;margin-right:50px">退出</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" style="width:120px">
            确定
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {
  checkName,
  checkPhone
} from '@/utils/validate'

// eslint-disable-next-line no-unused-vars
import { getPartnerDetail, addPartner, modifyPartner, getCreateSmsCode, getSelectBrandList, getZoneLayerList } from '@/api/setting'
import ChangePhone from './components/changePhone'
export default {
  components: {
    ChangePhone
  },
  data () {
    return {
      formLoading: false,
      confirmLoading: false,
      isEdit: false, // 判断是新建还是编辑状态
      brandOptions: [],
      areaOptions: [],
      ruleForm: {
        userName: '',
        phone: '',
        phoneCode: '',
        userAccount: '',
        brandIdList: [],
        zoneIdList: [],
        selectedZoneIdList: []
      },
      count: 60,
      timer: null,
      sendMsgLoading: false,
      rules: {
        userName: [{ required: true, validator: checkName, trigger: 'change' }],
        phone: [{ required: true, validator: checkPhone, trigger: 'change' }],
        phoneCode: [{ required: true, message: '请输入验证码', trigger: 'change' }],
        userAccount: [
          { required: true, message: '请输入账号', trigger: 'change' }
        ],
        brandIdList: [{ required: true, message: '请选择品牌', trigger: 'change' }],
        selectedZoneIdList: [{ required: true, message: '请选择所属区域', trigger: 'change' }]
      }
    }
  },
  mounted () {
    this.getSelectBrandList()
    this.getZoneLayerList()
    const { id } = this.$route.query
    if (id) {
      this.isEdit = true
      this.getPartnerDetail(id)
      this.handleUPdateVisitedView('编辑加盟商')
    } else {
      this.isEdit = false
      this.handleUPdateVisitedView('新建加盟商')
    }
  },
  watch: {
    areaOptions: {
      handler (newVal, oldVal) {
        if (newVal.length > 0 && Array.isArray(newVal) && this.ruleForm.selectedZoneIdList.length > 0) {
          const arr = this.ruleForm.selectedZoneIdList.map((key) => {
            return this.changeDetSelect(key, newVal)
          })
          this.ruleForm.selectedZoneIdList = arr
        }
      },
      deep: true
    }
  },
  methods: {
    handleUPdateVisitedView (title) {
      this.$route.meta.title = title
      document.title = title
      this.$store.dispatch('updateVisitedViews', this.$route)
    },
    queryCascader (id, subZoneList, valueArr = []) {
      for (var i = 0; i < subZoneList.length; i++) {
        const item = subZoneList[i]
        if (item.id === id) {
          return valueArr.concat([id])
        } else if (item.subZoneList) {
          const result = this.queryCascader(id, item.subZoneList, valueArr.concat([item.id]))
          if (result) {
            return result
          }
        }
      }
    },
    // 回显(多级)
    changeDetSelect (key, treeData) {
      const arr = [] // 在递归时操作的数组
      let returnArr = [] // 存放结果的数组
      let depth = 0 // 定义全局层级
      // 定义递归函数
      function childrenEach (childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN // 将执行的层级赋值 到 全局层级
          arr[depthN] = childrenData[j].id
          if (childrenData[j].id === key) {
            returnArr = arr.slice(0, depthN + 1) // 将目前匹配的数组，截断并保存到结果数组，
            break
          } else {
            if (childrenData[j].subZoneList) {
              depth++
              childrenEach(childrenData[j].subZoneList, depth)
            }
          }
        }
        return returnArr
      }
      return childrenEach(treeData, depth)
    },
    getPartnerDetail (id) {
      this.formLoading = true
      getPartnerDetail({ id }).then(response => {
        this.formLoading = false
        if (+response.error_code === 0) {
          this.ruleForm = Object.assign({}, this.ruleForm, response.data)
          this.ruleForm.brandIdList = response.data.brandList.map(item => item.brandId)
          this.ruleForm.selectedZoneIdList = response.data.zoneList.map(item => item.zoneId)
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    getSelectBrandList () {
      getSelectBrandList().then(response => {
        if (+response.error_code === 0) {
          this.brandOptions = response.data.list
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    getZoneLayerList () {
      getZoneLayerList().then(response => {
        if (+response.error_code === 0) {
          // this.areaOptions.push(response.data.zoneLayer)
          this.areaOptions = response.data.zoneLayer.subZoneList
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    // 获取选中的区域的叶子节点的id
    getZoneID (val) {
      val.forEach((item) => {
        this.ruleForm.zoneIdList.push(item[item.length - 1])
      })
    },
    countOperation () {
      this.timer = setInterval(() => {
        this.count = this.count - 1
        if (this.count === 0) {
          this.resetTimer()
        }
      }, 1000)
    },
    resetTimer () {
      clearInterval(this.timer)
      this.count = 60
    },
    sendMsg () {
      this.$refs.ruleForm.validateField(['phone'], formError => {
        if (!formError) {
          this.sendMsgLoading = true
          const params = {
            phone: this.ruleForm.phone
          }
          getCreateSmsCode(params).then(data => {
            console.log('data: ', data)
            if (+data.error_code === 0) {
              this.countOperation()
            } else {
              this.$message.error(data.error_msg)
            }
            this.sendMsgLoading = false
          })
        } else {
          console.log('formError表单填写有误，请核对！')
          return false
        }
      })
    },
    handleGoout () {
      this.$router.push({ path: '/MerchantSetting/MerchantInfoSetting/partner-management' })
    },
    submitForm (formName) {
      this.ruleForm.zoneIdList = []
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.getZoneID(this.ruleForm.selectedZoneIdList)
          this.confirmLoading = true
          if (!this.isEdit) { // 新建加盟商
            addPartner(this.ruleForm).then(data => {
              this.sendMsgLoading = false
              if (+data.error_code === 0) {
                this.$message.success('新建成功')
              } else {
                this.$message.error(data.error_msg)
              }
            })
          } else { // 编辑加盟商
            modifyPartner(this.ruleForm).then(data => {
              this.sendMsgLoading = false
              if (+data.error_code === 0) {
                this.$message.success('编辑成功')
              } else {
                this.$message.error(data.error_msg)
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
